module.exports = require("redux-watch");


//////////////////
// WEBPACK FOOTER
// external "redux-watch"
// module id = 4
// module chunks = 0


// WEBPACK FOOTER //
// webpack:/external "redux-watch"